export const PolyMaterialType = [
    {id: 0, name: "LD"},
    {id: 1, name: "PP"},
    {id: 2, name: "BOPP"},
]